import React, { createContext, useContext, useState, useEffect } from 'react';

import api from '../api/api';
import { AuthContext } from './AuthContext';

/* 
 * This code sets up a chat context and provider for a React application.
 * It manages chat messages and fetches conversation history from an API.
 */

// Create a context for chat
const ChatContext = createContext();

// Custom hook to easily access the chat context
export const useChat = () => {
  return useContext(ChatContext);
};

// Provider component for chat context
export const ChatProvider = ({ children }) => {
  // State to store chat messages
  const [messages, setMessages] = useState([]);
  const { isAuthenticated, userType } = useContext(AuthContext);

  const isRegisteredUser = isAuthenticated && userType === 'registered';
  const isGuestUser = isAuthenticated && userType === 'unregistered';

  useEffect(() => {
    // Function to fetch conversation history from the API
    const fetchConversationHistory = async () => {
      try {
        if (isRegisteredUser) {
          const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/api/chat/conversation-history`);
          setMessages(response.data.conversationHistory);
        }
      } catch (error) {
        console.error('Error fetching conversation history:', error);
      }
    };

    // Fetch conversation history when the component mounts
    fetchConversationHistory();
  }, [isRegisteredUser]);

  return (
    <ChatContext.Provider value={{ messages, setMessages }}>
      {children}
    </ChatContext.Provider>
  );
};